import {Website} from "./website";
import {Utils} from "../../shared/utils/utils";
import {TypeUtils} from "../../shared/utils/type-utils";
import {WebsiteTag} from "./website-tag";
import punycode from "punycode";

export class WebsiteMapper {

  public static map(data: any, allWebsites): Website {
    const website: Website = new Website();
    const otherData = data.other_data ? JSON.parse(data.other_data) : null;
    const mockScore  = {
      current_score: {
        date: new Date().toDateString(),
        desktop_score: 100,
        desktop_tti: 0.3,
        mobile_score: 100,
        mobile_tti: 1.7,
        tool: ""
      },
      previous_score: {
        date: new Date().toDateString(),
        desktop_score: 100,
        desktop_tti: 0.3,
        mobile_score: 100,
        mobile_tti: 1.7,
        tool: ""
      }
    };
    const _score = !data.score || data?.score?.current_score?.desktop_score === 101 ? mockScore : data.score ? data.score : null;
    website.id = data.id;
    website.name = data.name;
    website.site_url = data.site_url; // TODO CHECK
    website.title = this.modifyTitle(data.site_title);
    website.screenShotUrl = '';
    website.cloudflareEnabled = !!data.cloudflare_enabled;
    website.screenshot = data.screenshot;
    website.score = _score && WebsiteMapper.mapScoreData(_score) || null;
    website.creationDate = data.created_at ? Utils.getDate(data.created_at) : null;
    website.isActive = Utils.isTruthy(data.active);
    website.adminUrl = data.admin_url + '/';
    website.adminElementorUrl = Utils.addQueryString(website.site_url + '/wp-admin/', 'redirect=edit_front_page');
    website.adminFrontUrl = Utils.addQueryString(website.site_url + '/wp-admin/', 'redirect=view_front_page');
    website.adminPluginsUrl = website.adminUrl + 'plugins.php';
    website.adminBoosterSettingsPage = Utils.addQueryString(website.adminUrl + 'options-general.php', 'page=two_settings_page');
    website.adminImageOptimizerUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=iowd_dashboard');
    website.adminImageOptimizerUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=iowd_settings');
    website.adminActivateBoosterUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=onboarding_iowd&locked_features');
    website.adminEcommerceEmailPreviewUrl = Utils.addQueryString(website.site_url + '/wp-admin/', 'twwp_preview_woocommerce_mail=true');
    website.adminEcommerceUrls = {
      'orders' : Utils
      .addQueryString(website.adminUrl + 'edit.php?post_type=shop_order', ''),
      'products' : Utils
      .addQueryString(website.adminUrl + 'edit.php?post_type=product', ''),
      'customers' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-admin&path=%2Fcustomers'),
      'analytics' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-admin&path=%2Fanalytics%2Foverview'),
      'marketing' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-admin&path=%2Fmarketing'),
      'payment' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-settings&tab=checkout'),
      'shipping' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-settings&tab=shipping'),
      'tax' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-settings&tab=tax'),
      'emails' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-settings&tab=email'),
      'emailName' : Utils
      .addQueryString(website.adminUrl + 'admin.php', 'page=wc-settings&tab=email&section=sectionId'),
      'navigation' : Utils
      .addQueryString(website.adminUrl + 'nav-menus.php?action=edit', ''),
      'refund' : Utils
      .addQueryString(website.adminUrl + 'admin.php', `page=wc-orders&action=edit&id=orderId`),
    };
    website.adminBackupsUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=buwd_backups');
    website.adminJobsUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=buwd_jobs');
    website.adminLogsUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=buwd_logs');
    website.adminSearchAnalyticsUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_overview');
    website.adminSearchConsoleUrl = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_search_console');
    website.adminBuilderCreatePage = website.adminUrl + 'post-new.php';
    website.adminUsersPage = website.adminUrl + 'users.php';
    website.ftpSettingsValid = otherData && otherData.file_system && Utils.isTruthy(otherData.file_systemconfig);
    website.lastUpdated = otherData && otherData.multisite_data && otherData.multisite_data.last_updated ? new Date(otherData.multisite_data.last_updated) : new Date();
    website.registeredAt = otherData && otherData.multisite_data && otherData.multisite_data.registered ? new Date(otherData.multisite_data.registered) : new Date();
    website.isLocalhost = !Utils.isTruthy(data.is_available);
    website.loggedOut = Utils.isTruthy(data.logged_out);
    website.php_version = data.php_version;
    website.canActivateServices = data.php_version ? data.php_version.substring(0, 3) >= "5.5" : false;
    website.platformVersion = data.platform_version;
    website.manualOptimizationStatus = data.manual_optimization_status;
    website.isMigrated = data.migrated_from || false;
    website.type = data.type === 'dev' ? 'staging' : "live";
    website.selected = false;
    website.serverType = data.server_type;
    website.httpsEnabled = 1; /// TODO
    website.domain_hash = data.domain_hash; /// TODO
    const siblingId = data.domain_hash ? allWebsites.find((domains: any): any => (domains.domain_hash === data.domain_hash && domains.id !== data.id)) ? allWebsites.find((domains: any): any => (domains.domain_hash === data.domain_hash && domains.id !== data.id)).id : "" : "";
    if (siblingId) {
      if (data.type === 'dev') {
        website.siblingId = {
          live: siblingId,
          dev: data.id
        };
      }
      else {
        website.siblingId = {
          live: data.id,
          dev: siblingId
        };
      }
    }
    else {
      website.siblingId = "";
    }
    website.adminSeoOverview = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_overview');
    website.adminSearchAnalytics = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_overview');
    website.adminFixIssues = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_search_console');
    website.adminSeoRedirects = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_redirects');
    website.adminSeoSiteMap = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_sitemap');
    website.adminSeoMetaData = Utils.addQueryString(website.adminUrl + 'admin.php', 'page=wdseo_meta_info');
    website.tagsDefaultList = data && data.website_tags && Object.values(data.website_tags).filter((tag: WebsiteTag): boolean => tag.title !== '');
    website.websiteTags = data && data.website_tags && Object.values(data.website_tags).join(",");
    website.tags = {...data.website_tags, 0: !!website.domain_hash ? 'Hosted' : 'Connected'};
    website.isNetwork = data.is_network || false;
    website.parentId = data.parent || null;
    website.children = data.children || null;
    website.multisiteType = data.multisite_type || null;
    website.whiteLabel = data.white_label_id || null;
    website.manualMigrationStatus = data.manual_migration_status || null;
    website.whiteLabled = !!data.white_label_id;
    website.migrated_from = data.migrated_from || null;
    website.hasCopy = data.domain_hash ? false : !!allWebsites.find(domain => (domain.migrated_from && domain.migrated_from.replace(/(^\w+:|^)\/\//, '')) === (website.site_url && website.site_url.replace(/(^\w+:|^)\/\//, '')));
    website.isStopped = data.is_stopped;
    website.connectedFrom = data.connected_from_plugin;
    website.isAiConnected = !!data.is_ai_connected;
    website.isAiBuilderDemo = !!data.ai_builder_demo;
    website.managerVersionIO = data.manager_version && !!data.manager_version.includes('iowd');
    website.managerVersion = data.manager_version;
    website.isEcommerceWebsite = [data.template_type, data.website_type].includes('ecommerce');
    website.builderType = data.builder_type;
    website.isWVC = [data.builder_type].includes('wvc');
    website.isSectionBased = [data.builder_type].includes('section_based');
    website.styles = data.styles;
    website.websiteType = data.website_type;
    return website;
  }

  public static mapScoreData (data) {
    let score;
    if (data && TypeUtils.isDefined(data.current_score)) {
      if (!TypeUtils.isNull(data.current_score)) {
        score = {
          currentScore: {
            desktopScore: data.current_score.desktop_score,
            mobileScore: data.current_score.mobile_score,
            desktopTTI: data.current_score.desktop_tti,
            mobileTTI: data.current_score.mobile_tti,
            date: data.current_score.date
          }
        };
      }
      else {
        score = {
          currentScore: {
            desktopScore: null,
            mobileScore: null,
            desktopTTI: null,
            mobileTTI: null,
            date: null
          }
        };
      }
    }
    if (data && TypeUtils.isDefined(data.previous_score)) {
      if (!TypeUtils.isNull(data.previous_score)) {
        score = Object.assign({}, score, {
          previousScore: {
            desktopScore: data.previous_score.desktop_score,
            mobileScore: data.previous_score.mobile_score,
            desktopTTI: data.previous_score.desktop_tti,
            mobileTTI: data.previous_score.mobile_tti,
            date: data.previous_score.date
          }
        });
      }
      else {
        score = Object.assign({}, score, {
          previousScore: {
            desktopScore: null,
            mobileScore: null,
            desktopTTI: null,
            mobileTTI: null,
            date: null
          }
        });
      }

    }
    if (data && TypeUtils.isDefined(data.original_score)) {
      if (!TypeUtils.isNull(data.original_score)) {
        score = Object.assign({}, score, {
          originalScore: {
            desktopScore: data.original_score.desktop_score,
            mobileScore: data.original_score.mobile_score,
            desktopTTI: data.original_score.desktop_tti,
            mobileTTI: data.original_score.mobile_tti,
            date: data.original_score.date
          }
        });
      }
      else {
        score = Object.assign({}, score, {
          originalScore: {
            desktopScore: null,
            mobileScore: null,
            desktopTTI: null,
            mobileTTI: null,
            date: null
          }
        });
      }

    }
    /*if (TypeUtils.isObject(data)) {
      score = data;
    }*/
    return score;
  }

  public static toUnicode(value): string {
    const separator = '://';
    const urlParts = value.split(separator);
    const unicodeValue = punycode.toUnicode(urlParts[1]);
    return `${urlParts[0]}${separator}${unicodeValue}`;
  }

  private static modifyTitle(_title) {
    let title = decodeURI(encodeURI(_title));
    return title.split(':')[0];
  }
}
